import { render, staticRenderFns } from "./detail_search1.vue?vue&type=template&id=20787847&scoped=true&"
import script from "./detail_search1.vue?vue&type=script&lang=js&"
export * from "./detail_search1.vue?vue&type=script&lang=js&"
import style0 from "./detail_search1.vue?vue&type=style&index=0&id=20787847&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20787847",
  null
  
)

export default component.exports